import http from '@/utils/http-service'
const apiPath = require('@/apiPath/api.js')
export default {
  merchantLogo: '',
  merchantIcon: '',
  setLogo (merchantLogo) {
    this.merchantLogo = merchantLogo
  },
  setIcon (merchantIcon) {
    this.merchantIcon = merchantIcon
  }
  // getCommIdCustomUi: new Promise((resovle, reject) => {
  //     http(apiPath.getCommIdCustomUi, { commId: 34497 }, 'get').then(res => {
  //         resovle(res.data)
  //         reject(res)
  //     })
  // })
}



// WEBPACK FOOTER //
// ./src/global_variable.js